import React, { useContext } from 'react';
import {
    FormErrorMessage,
    FormLabel,
    FormControl,
    Input,
    Button,
    Textarea,
    Heading,
    Box,
} from '@chakra-ui/core';
import { useForm } from 'react-hook-form';
import { useAddCommentMutation } from '../mutations/addComment';

import { useUserQuery } from '../../config/userQuery';

import { AuthContext } from '../../context/auth';

const AddCommentForm = ({ loading }) => {
    const userData = useUserQuery();
    const { user } = useContext(AuthContext);
    // const user = {};
    //console.log(!user);

    const { handleSubmit, errors, register } = useForm();
    const [eventContact, commentResults] = useAddCommentMutation(errors);
    const disableForm = commentResults.loading || loading;
    const onSubmit = (values, errors) => {
        user.first_name !== undefined
            ? eventContact((values.id = `${user.id}`), values.commentText, errors.commentText)
            : eventContact(values.id, values.commentText, errors.commentText, errors.id);
    };
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FormControl mb='5' isInvalid={errors.commentText}>
                    {/* <FormLabel htmlFor='name'>Comment</FormLabel> */}
                    <Textarea
                        name='commentText'
                        color="black"
                        placeholder='Scrivi qui il messaggio ...'
                        ref={register({
                            required: { value: true, message: 'Questo campo è obbligatorio' },
                        })}
                    ></Textarea>
                    <FormErrorMessage>
                        {errors.commentText?.message || errors.commentText}
                    </FormErrorMessage>
                </FormControl>
                <Button type='submit' size='lg' colorScheme='brand' disabled={disableForm}>
                    Send
                </Button>
            </form>
        </>
    );
};
export default AddCommentForm;
